import i18n from '@/i18n'
import store from '@/store'

var uiHelper = () => {
	/**
	 * 是否显示loading
	 * @param boolean isShow 是否显示 true/false
	 */
	var loading = isShow => {
		store.commit('loading', isShow)
	}

	/**
	 * 显示提示消息
	 * @param  {[type]} msg [description]
	 * @return [type]           [description]
	 */
	var msgBox = (msg, type, endFun, buttons) => {
		type = typeof type === 'undefined' ? 'info' : type
		buttons = typeof buttons === 'undefined' ? [i18n.t('_page.msgbox.ok')] : buttons

		var info = {content: msg, type: type, buttonList: buttons, endFun: endFun}

		store.commit('msgParam', info)
	}

	return {
		loading: loading,
		msgbox: msgBox
	}
}

export default {
	install: function (Vue) {
		if (uiHelper.installed) {
			return
		}
		uiHelper.installed = true
		Vue.prototype.uiHelper = uiHelper()
	},

	instance: uiHelper()
}



// WEBPACK FOOTER //
// ./src/helper/ui.js